export default "__VITE_ASSET__DGsazis6__"